import thinkingBubble from "../../assets/waveMic.gif"
export default function ThinkingBubble() {
  return (
    <img 
    src={thinkingBubble}
    alt="Active microphone" 
    width="300" 
    height="300"
  />
  );
}

